// En-tête X-Tenant-ID du front (T-123).
// Le serveur tranche le tenant depuis la SESSION (T-090/T-090d) : l'en-tête n'est qu'une
// indication. On ne l'envoie donc que si on a un slug de tenant VALIDE (chaîne) — jamais de
// valeur par défaut codée en dur (« tef », « climatpac », « jkc », « default »), jamais un objet.
const SLUG = /^[a-z0-9][a-z0-9_-]{0,63}$/i;

export function slugValide(valeur) {
  return typeof valeur === "string" && SLUG.test(valeur) && valeur.toLowerCase() !== "default";
}

/** `{ "X-Tenant-ID": slug }` si `valeur` est un slug valide, sinon `{}` (à étaler : `...enteteTenant(t)`). */
export function enteteTenant(valeur) {
  return slugValide(valeur) ? { "X-Tenant-ID": valeur } : {};
}
